import Breadcrumb from "components/Common/Breadcrumb"
import QwikForm from "components/form/QwikForm"
import QwikInput from "components/form/QwikInput"
import QwikSelect from "components/form/QwikSelect"
import React, { useEffect, useState } from "react"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Button,
  Badge,
  FormGroup,
  Label,
} from "reactstrap"
import { parseISO, formatISO, format } from "date-fns"
import { yupResolver } from "@hookform/resolvers/yup"
import { clientLeadsSchema } from "schemas/clientLeadsSchema"
import {
  useCreateClientLeadMutation,
  useGetClientLeadByIdQuery,
  useUpdateClientLeadMutation,
} from "store/features/clientLeads/clientLeadsManagement"
import { toast } from "sonner"
import { useParams } from "react-router-dom"
import DashboardLoader from "components/Loader/DashboardLoader"
import AddLeadSummaryModal from "components/Modals/AddLeadSummaryModal"

const SingleLeads = () => {
  const { id } = useParams()
  const [isEditing, setIsEditing] = useState(false)
  const [rows, setRows] = useState([{ id: 1, note: "" }])
  const [projectProposal, setProjectProposal] = useState(null)
  const [contract, setContract] = useState(null)

  const [leadSummaryModal, setLeadSummaryModal] = useState(false)
  const handleLeadSummaryAdded = () => {
    refetch() // Refresh the lead data
  }

  const {
    data: singleLeads,
    isLoading: loadingSingleLead,
    refetch,
  } = useGetClientLeadByIdQuery(id)
  const [updateClientLead, { isLoading }] = useUpdateClientLeadMutation()

  const [defaultValues, setDefaultValues] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    service_name: "",
    requirements: "",
    status: "",
    priority_status: "",
    start_date: null,
    end_date: null,
    follow_up_date: null,
    follow_up_time: "",
    summary: "",
  })

  useEffect(() => {
    if (singleLeads) {
      const formattedValues = {
        ...singleLeads,
        start_date: singleLeads.start_date
          ? format(parseISO(singleLeads.start_date), "yyyy-MM-dd")
          : null,
        end_date: singleLeads.end_date
          ? format(parseISO(singleLeads.end_date), "yyyy-MM-dd")
          : null,
        follow_up_date: singleLeads.follow_up_date
          ? format(parseISO(singleLeads.follow_up_date), "yyyy-MM-dd")
          : null,
        // follow_up_time: singleLeads.follow_up_time
        //   ? format(parseISO(singleLeads.follow_up_time), "HH:mm")
        //   : null,
        follow_up_time: singleLeads.follow_up_time
          ? format(parseISO(singleLeads.follow_up_time), "HH:mm")
          : null,

        // summary: singleLeads.summary?.map(item => item.note).join("\n") || "",
        summary: "",
      }
      setDefaultValues(formattedValues)
      // setRows(singleLeads.summary || [{ id: 1, note: "" }])
    }
  }, [singleLeads, loadingSingleLead])

  const handleFileChange = (setter, event) => {
    const file = event.target.files[0]
    setter(file)
  }

  const getFileName = file => {
    return file ? file.name : "No file chosen"
  }

  const getPriorityBadge = priority => {
    switch (priority) {
      case "1":
        return <Badge color="danger">High</Badge>
      case "2":
        return <Badge color="warning">Medium</Badge>
      case "3":
        return <Badge color="success">Low</Badge>
      default:
        return (
          <Badge color="secondary" style={{ color: "#666666" }}>
            Not Set
          </Badge>
        )
      // <Badge color="secondary">Not Set</Badge>
    }
  }

  const getStatusBadge = status => {
    switch (status) {
      case "new":
        return <Badge color="primary">New</Badge>
      case "in_progress":
        return <Badge color="warning">In Progress</Badge>
      case "completed":
        return <Badge color="success">Completed</Badge>
      default:
        return <Badge color="secondary">Unknown</Badge>
    }
  }

  // const getStatusBadge = status => {
  //   const statusConfig = {
  //     Pending: "warning",
  //     "In Progress": "primary",
  //     Completed: "success",
  //     "On Hold": "danger",
  //   }
  //   return statusConfig[status] || "secondary"
  // }

  const getFileViewLink = fileUrl => {
    if (!fileUrl) return null
    return `${fileUrl}`
  }

  const handleSubmit = async (data, methods) => {
    try {
      const startDate = data.start_date ? formatISO(data.start_date) : null
      const endDate = data.end_date ? formatISO(data.end_date) : null
      const followUpDate = data.follow_up_date
        ? formatISO(data.follow_up_date)
        : null

      // const followUpTime = data.follow_up_time
      //   ? formatISO(data.follow_up_time)
      //   : null

      const followUpTime =
        data.follow_up_time && data.follow_up_time !== ""
          ? formatISO(new Date(`1970-01-01T${data.follow_up_time}`))
          : null

      // Convert summary text into the required array format
      // const summaryArray = data.summary
      //   ? data.summary
      //       .split("\n")
      //       .filter(note => note.trim() !== "")
      //       .map((note, index) => ({
      //         id: index + 1,
      //         note: note.trim(),
      //       }))
      //   : []

      const summaryArray = data.summary
        ? singleLeads?.summary
          ? [
              ...(singleLeads?.summary || []),
              {
                id: (singleLeads?.summary?.length || 0) + 1,
                note: data.summary,
                date: new Date().toISOString().split("T")[0],
              },
            ]
          : [
              {
                id: 1,
                note: data.summary,
                date: new Date().toISOString().split("T")[0],
              },
            ]
        : singleLeads?.summary || []

      // Create FormData for file upload
      const formData = new FormData()
      formData.append("id", id)

      // Append all text fields
      formData.append("name", data.name || "")
      formData.append("email", data.email || "")
      formData.append("company", data.company || "")
      formData.append("phone", data.phone || "")
      formData.append("service_name", data.service_name || "")
      formData.append("requirements", data.requirements || "")
      formData.append("status", data.status || "")
      formData.append("priority_status", data.priority_status || "")
      if (startDate) formData.append("start_date", startDate)
      if (endDate) formData.append("end_date", endDate)
      if (followUpDate) formData.append("follow_up_date", followUpDate)
      if (followUpTime) formData.append("follow_up_time", followUpTime)
      formData.append("summary", JSON.stringify(summaryArray))
      formData.append("mark_client", singleLeads?.mark_client || false)

      // Append files if they exist
      if (projectProposal) {
        formData.append("project_proposal", projectProposal)
      }
      if (contract) {
        formData.append("contract", contract)
      }

      const response = await updateClientLead({ id, formData })

      if (response?.data?.id) {
        // Reset file states
        setProjectProposal(null)
        setContract(null)

        // Reset file input fields
        const projectProposalInput = document.getElementById("project_proposal")
        const contractInput = document.getElementById("contract")
        if (projectProposalInput) projectProposalInput.value = ""
        if (contractInput) contractInput.value = ""

        setIsEditing(false)
        refetch()
        toast.success("Client lead updated successfully")
      } else {
        toast.error("Error updating client lead")
      }
    } catch (error) {
      console.error("Submission error:", error)
      toast.error("Failed to update client lead")
    }
  }

  const handleCancelEdit = () => {
    setIsEditing(false)
    // Reset to original values
    if (singleLeads) {
      const formattedValues = {
        ...singleLeads,
        start_date: singleLeads.start_date
          ? format(parseISO(singleLeads.start_date), "yyyy-MM-dd")
          : null,
        end_date: singleLeads.end_date
          ? format(parseISO(singleLeads.end_date), "yyyy-MM-dd")
          : null,
        follow_up_date: singleLeads.follow_up_date
          ? format(parseISO(singleLeads.follow_up_date), "yyyy-MM-dd")
          : null,

        follow_up_time: singleLeads.follow_up_time
          ? format(parseISO(singleLeads.follow_up_time), "HH:mm")
          : null,

        // summary: singleLeads.summary?.map(item => item.note).join("\n") || "",
        summary: "",
      }
      setDefaultValues(formattedValues)
    }
  }

  if (loadingSingleLead) {
    return <DashboardLoader />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Qwik IT" breadcrumbItem="Lead Details" />

          {/* Header with Actions */}
          <Row className="mb-4">
            <Col>
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Lead Information</h4>

                <div className="d-flex gap-3">
                  {!isEditing && (
                    <Button
                      color="success"
                      onClick={() => setLeadSummaryModal(true)}
                      className="ms-2"
                    >
                      <i className="fas fa-plus me-1"></i> Add Summary
                    </Button>
                  )}
                  {!isEditing ? (
                    <Button color="primary" onClick={() => setIsEditing(true)}>
                      <i className="bx bx-edit me-1"></i> Edit Lead
                    </Button>
                  ) : (
                    <Button color="secondary" onClick={handleCancelEdit}>
                      <i className="bx bx-x me-1"></i> Cancel
                    </Button>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          {!isEditing ? (
            /* VIEW MODE */
            <Row>
              <Col lg={8}>
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4
                        className="card-title mb-0 text-primary"
                        style={{ fontSize: "18px" }}
                      >
                        Project Information
                      </h4>
                      <p className="fs-6 bg-success text-white px-2 rounded">
                        {/* {getStatusBadge(singleLeads?.status)} */}
                        {singleLeads?.status}
                      </p>
                    </div>

                    <Row>
                      {/* <Col md={6}>
                        <h6 className="text-muted">Personal Information</h6>
                        <div className="mb-3">
                          <strong>Name:</strong> {singleLeads?.name}
                        </div>
                        <div className="mb-3">
                          <strong>Email:</strong> {singleLeads?.email}
                        </div>
                        <div className="mb-3">
                          <strong>Phone:</strong> {singleLeads?.phone}
                        </div>
                        <div className="mb-3">
                          <strong>Company:</strong> {singleLeads?.company}
                        </div>
                      </Col> */}

                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Service
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads?.service_name || "N/A"}
                          </p>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Priority
                          </label>
                          <p>
                            {getPriorityBadge(singleLeads?.priority_status)}
                          </p>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Project Proposal
                          </label>
                          <div>
                            {singleLeads?.project_proposal ? (
                              <a
                                href={getFileViewLink(
                                  singleLeads.project_proposal
                                )}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fas fa-file-pdf me-1"></i> View
                                Proposal
                              </a>
                            ) : (
                              <span className="text-muted">
                                No proposal uploaded
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Contract
                          </label>
                          <p>
                            {singleLeads?.contract ? (
                              <a
                                href={getFileViewLink(singleLeads.contract)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fas fa-file-contract me-1"></i>{" "}
                                View Contract
                              </a>
                            ) : (
                              <span className="text-muted">
                                No contract uploaded
                              </span>
                            )}
                          </p>
                        </div>
                      </Col>

                      {/* <Col md={6}> */}
                      {/* <div className="mb-3">
                          <strong>Service:</strong> {singleLeads?.service_name}
                        </div> */}
                      {/* <div className="mb-3">
                          <strong>Status:</strong>{" "}
                          {getStatusBadge(singleLeads?.status)}
                        </div> */}
                      {/* <div className="mb-3">
                          <strong>Priority:</strong>{" "}
                          {getPriorityBadge(singleLeads?.priority_status)}
                        </div> */}
                      {/* <div className="mb-3">
                          <strong>Mark as Client:</strong>
                          <Badge
                            color={
                              singleLeads?.mark_client ? "success" : "secondary"
                            }
                            className="ms-2"
                          >
                            {singleLeads?.mark_client ? "Yes" : "No"}
                          </Badge>
                        </div> */}
                      {/* </Col> */}
                    </Row>

                    <Row className="mt-3">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4
                          className="card-title mb-0 text-primary"
                          style={{ fontSize: "18px" }}
                        >
                          Timeline
                        </h4>
                      </div>

                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Start Date
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads?.start_date
                              ? format(
                                  parseISO(singleLeads.start_date),
                                  "MMM dd, yyyy"
                                )
                              : "Not set"}
                          </p>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            End Date
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads?.end_date
                              ? format(
                                  parseISO(singleLeads.end_date),
                                  "MMM dd, yyyy"
                                )
                              : "Not set"}
                          </p>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Follow Up Date
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads?.follow_up_date
                              ? format(
                                  parseISO(singleLeads.follow_up_date),
                                  "MMM dd, yyyy"
                                )
                              : "Not set"}
                          </p>
                        </div>
                      </Col>

                      {/* <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Follow Up Time
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads?.follow_up_time
                              ? format(
                                  parseISO(singleLeads.follow_up_time),
                                  "hh:mm a"
                                )
                              : "Not set"}
                          </p>
                        </div>
                      </Col> */}

                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Follow Up Time
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads?.follow_up_time &&
                            singleLeads.follow_up_time !== ""
                              ? format(
                                  parseISO(singleLeads.follow_up_time),
                                  "hh:mm a"
                                )
                              : "Not set"}
                          </p>
                        </div>
                      </Col>

                      {/* <Col md={6}>
                        <div className="mb-3">
                          <strong>Start Date:</strong>{" "}
                          {singleLeads?.start_date
                            ? format(
                                parseISO(singleLeads.start_date),
                                "MMM dd, yyyy"
                              )
                            : "Not set"}
                        </div>
                        <div className="mb-3">
                          <strong>End Date:</strong>{" "}
                          {singleLeads?.end_date
                            ? format(
                                parseISO(singleLeads.end_date),
                                "MMM dd, yyyy"
                              )
                            : "Not set"}
                        </div>
                      </Col> */}
                    </Row>

                    <Row className="mt-3">
                      <Col>
                        <h6
                          className="text-primary"
                          style={{ fontSize: "16px" }}
                        >
                          Requirements
                        </h6>
                        <div className="border p-3 rounded bg-light bg-gradient">
                          {singleLeads?.requirements ||
                            "No requirements specified"}
                        </div>
                      </Col>
                    </Row>

                    {/* {singleLeads?.summary && singleLeads.summary.length > 0 && (
                      <Row className="mt-3">
                        <Col>
                          <h6
                            className="text-muted"
                            style={{ fontSize: "16px" }}
                          >
                            Summary
                          </h6>
                          <div className="border p-3 rounded bg-light bg-gradient">
                            {singleLeads.summary.map((item, index) => (
                              <div
                                key={item.id}
                                className=" d-flex align-items-start justify-content-between mb-2"
                              >
                                <div className="d-flex align-items-start">
                                  <Badge color="light" className="me-2 mt-1">
                                    {index + 1}.
                                  </Badge>
                                  <span>{item.note}</span>
                                </div>

                                <div
                                  className="text-muted"
                                  style={{ fontSize: "13px" }}
                                >
                                  {item.date}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    )} */}

                    <Row className="mt-4">
                      <h6 className="text-primary" style={{ fontSize: "16px" }}>
                        Lead Summary
                      </h6>

                      {singleLeads?.summary &&
                      singleLeads.summary.length > 0 ? (
                        <Col>
                          <div className="">
                            {singleLeads.summary.map((item, index) => (
                              <div
                                key={item.id || index}
                                className="border rounded p-3 mb-3"
                                style={{ backgroundColor: "#F2F2F2" }}
                              >
                                {/* Header Row - Name, Date, Hours */}
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <div>
                                    <strong className="fs-6">
                                      {item.employer_name} ({item.employer_role}
                                      )
                                    </strong>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <div className="text-muted small me-3">
                                      {item.date}
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="badge bg-info">
                                        {item.hours_spent}h
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* Title (if exists) */}
                                {/* {item.title && (
                                  <div className="mb-2">
                                    <strong className="text-dark">
                                      {item.title}
                                    </strong>
                                  </div>
                                )} */}

                                {/* Lead Summary */}
                                <div className="mt-2">
                                  <div className="text-dark">
                                    {item.lead_summary}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </Col>
                      ) : (
                        <Col>
                          <div className="text-center py-4">
                            <i className="fas fa-clipboard-list fa-2x text-muted mb-2"></i>
                            <p className="text-muted mb-0">
                              {isLoading
                                ? "Loading summary..."
                                : "No summary available for this lead"}
                            </p>
                          </div>
                        </Col>
                      )}
                    </Row>

                    {/* <Row className="mt-3">
                      <Col md={6}>
                        <h6 className="text-muted">Attachments</h6>
                        <div className="mb-3">
                          <strong>Project Proposal:</strong>{" "}
                          {singleLeads?.project_proposal ? (
                            <a
                              href={singleLeads.project_proposal}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="ms-2"
                            >
                              View File
                            </a>
                          ) : (
                            <span className="text-muted ms-2">No file</span>
                          )}
                        </div>
                        <div className="mb-3">
                          <strong>Contract:</strong>{" "}
                          {singleLeads?.contract ? (
                            <a
                              href={singleLeads.contract}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="ms-2"
                            >
                              View File
                            </a>
                          ) : (
                            <span className="text-muted ms-2">No file</span>
                          )}
                        </div>
                      </Col>
                    </Row> */}
                  </CardBody>
                </Card>
              </Col>

              <Col lg={4}>
                {/* Client Card */}
                <Card className="mb-4">
                  <CardBody>
                    <h4
                      style={{ fontSize: "18px" }}
                      className="card-title mb-3 text-primary"
                    >
                      Personal Information
                    </h4>
                    {singleLeads ? (
                      <>
                        <div className="mb-2 d-flex gap-2">
                          <label className="form-label fw-semibold">
                            Name:
                          </label>
                          <p className="text-muted mb-0">{singleLeads.name}</p>
                        </div>
                        <div className="mb-2 d-flex gap-2">
                          <label className="form-label fw-semibold">
                            Email:
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads.email || "N/A"}
                          </p>
                        </div>
                        {/* <div className="mb-2 d-flex gap-2">
                                    <label className="form-label fw-semibold">Email:</label>
                                    <p className="text-muted mb-0">{singleLeads.user_info?.personal_email || "N/A"}</p>
                                  </div> */}
                        <div className="mb-2 d-flex gap-2">
                          <label className="form-label fw-semibold">
                            Phone:
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads.phone || "N/A"}
                          </p>
                        </div>
                        <div className="mb-2 d-flex gap-2">
                          <label className="form-label fw-semibold">
                            Company:
                          </label>
                          <p className="text-muted mb-0">
                            {singleLeads.company || "N/A"}
                          </p>
                        </div>
                        {/* <div className="mb-2 d-flex gap-2">
                                    <label className="form-label fw-semibold">Notes:</label>
                                    <p className="text-muted mb-0">{singleLeads.notes || "N/A"}</p>
                                  </div> */}
                      </>
                    ) : (
                      <p className="text-muted">
                        No client information available
                      </p>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            /* EDIT MODE */
            <Row>
              <QwikForm
                onSubmit={handleSubmit}
                resolver={yupResolver(clientLeadsSchema)}
                defaultValues={defaultValues}
                encType="multipart/form-data"
              >
                <Col className="col-12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={6}>
                          <div className="mb-3">
                            <QwikInput
                              name="name"
                              label="Name"
                              placeholder="Enter Name"
                              type="text"
                              className="form-control"
                              required={true}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <QwikInput
                              name="email"
                              label="Email"
                              placeholder="Enter Email"
                              type="email"
                              className="form-control"
                              required={true}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <QwikInput
                              name="company"
                              label="Company Name"
                              placeholder="Enter Company Name"
                              type="text"
                              className="form-control"
                              required
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="mb-3">
                            <QwikInput
                              name="phone"
                              label="Phone"
                              placeholder="Enter Phone"
                              type="text"
                              className="form-control"
                              required
                            />
                          </div>
                        </Col>
                        {/* <Col lg={6}>
                          <div className="mb-3">
                            <QwikInput
                              name="service_name"
                              label="Service Name"
                              placeholder="Enter Service Name"
                              type="text"
                              className="form-control"
                              required
                            />
                          </div>
                        </Col> */}

                        <Col lg={6}>
                          <div className="mb-3">
                            <QwikSelect
                              name="service_name"
                              label="Service Name"
                              options={[
                          {
                            value: "Website Development",
                            label: "Website Development",
                          },
                          {
                            value: "Mobile App - Android",
                            label: "Mobile App - Android",
                          },
                          {
                            value: "Mobile App - iOS",
                            label: "Mobile App - iOS",
                          },
                          {
                            value: "Mobile App - Android & iOS (Both)",
                            label: "Mobile App - Android & iOS (Both)",
                          },
                          {
                            value: "Website + Mobile App",
                            label: "Website + Mobile App",
                          },
                          {
                            value: "E-Commerce Solution",
                            label: "E-Commerce Solution",
                          },
                          {
                            value: "POS System",
                            label: "POS System",
                          },
                          {
                            value: "CRM / ERP System",
                            label: "CRM / ERP System",
                          },
                          {
                            value: "Service Platform (App / Web)",
                            label: "Service Platform (App / Web)",
                          },
                          {
                            value: "Digital Marketing",
                            label: "Digital Marketing",
                          },
                          {
                            value: "Custom Software Development",
                            label: "Custom Software Development",
                          },
                          {
                            value: "Website + Mobile App (Android & iOS) + CRM",
                            label: "Website + Mobile App (Android & iOS) + CRM",
                          },
                          {
                            value: "Website + Mobile App (Android & iOS) + CRM + ERP",
                            label: "Website + Mobile App (Android & iOS) + CRM + ERP",
                          },
                          {
                            value: "All-in-One Solution (Website, App, CRM, POS & Marketing)",
                            label: "All-in-One Solution (Website, App, CRM, POS & Marketing)",
                          },
                        ]}
                              required
                            />
                          </div>
                        </Col>

                        {/* Priority Status */}
                        <Col lg={6}>
                          <div className="mb-3">
                            <QwikSelect
                              name="priority_status"
                              label="Priority Status"
                              options={[
                                { value: "1", label: "High" },
                                { value: "2", label: "Medium" },
                                { value: "3", label: "Low" },
                              ]}
                            />
                          </div>
                        </Col>

                        <Col lg={6}>
                          <div className="mb-3">
                            <QwikInput
                              name="requirements"
                              label="Requirements"
                              placeholder="Enter Requirements"
                              type="textarea"
                              className="form-control"
                              required
                            />
                          </div>
                        </Col>

                        {/* <Col lg={6}>
                          <div className="mb-4">
                            <QwikInput
                              name="summary"
                              label="Summary Notes"
                              placeholder="Enter summary"
                              type="textarea"
                              className="form-control"
                              helperText="summary."
                            />
                          </div>
                        </Col> */}

                        {/* <Col lg={4}>
                          <div className="mb-3">
                            <QwikSelect
                              name="status"
                              label="Status"
                              options={[
                                { value: "new", label: "New" },
                                { value: "in_progress", label: "In Progress" },
                                { value: "completed", label: "Completed" },
                              ]}
                            />
                          </div>
                        </Col> */}

                        <Col lg={4}>
                          <div className="mb-3">
                            <QwikSelect
                              name="status"
                              label="Status"
                              options={[
                                {
                                  value: "Not received",
                                  label: "Not received",
                                },
                                { value: "Busy", label: "Busy" },
                                { value: "Sent demo", label: "Sent demo" },
                                {
                                  value: "Sent proposal",
                                  label: "Sent proposal",
                                },
                                {
                                  value: "Wanna visit office",
                                  label: "Wanna visit office",
                                },
                                {
                                  value: "Wanna zoom meeting",
                                  label: "Wanna zoom meeting",
                                },
                                {
                                  value: "Sent proposal but no response",
                                  label: "Sent proposal but no response",
                                },
                                {
                                  value:
                                    "Sent demo, he will review and back to us",
                                  label:
                                    "Sent demo, he will review and back to us",
                                },
                                {
                                  value: "Knocked by mistake",
                                  label: "Knocked by mistake",
                                },
                                {
                                  value: "He has low budget",
                                  label: "He has low budget",
                                },
                                {
                                  value: "He will knock us when he need",
                                  label: "He will knock us when he need",
                                },
                              ]}
                            />
                          </div>
                        </Col>

                        <Col lg={4}>
                          <div className="mb-3">
                            <QwikInput
                              name="start_date"
                              label="Start Date"
                              placeholder="Enter Start Date"
                              type="date"
                              className="form-control"
                            />
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div className="mb-4">
                            <QwikInput
                              name="end_date"
                              label="End Date"
                              placeholder="Enter End Date"
                              type="date"
                              className="form-control"
                            />
                          </div>
                        </Col>

                        {/* Project Proposal File Upload */}
                        <Col lg={3}>
                          <FormGroup>
                            <Label
                              for="project_proposal"
                              className="form-label"
                            >
                              Project Proposal{" "}
                              {singleLeads?.project_proposal && (
                                <a
                                  href={singleLeads.project_proposal}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="ms-2 text-primary"
                                >
                                  (View Current)
                                </a>
                              )}
                            </Label>
                            <div className="custom-file">
                              <input
                                type="file"
                                className="custom-file-input"
                                id="project_proposal"
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                onChange={e =>
                                  handleFileChange(setProjectProposal, e)
                                }
                              />
                              {/* <label
                                className="custom-file-label"
                                htmlFor="project_proposal"
                              >
                                {getFileName(projectProposal)}
                              </label> */}
                            </div>
                          </FormGroup>
                        </Col>

                        {/* Contract File Upload */}
                        <Col lg={3}>
                          <FormGroup>
                            <Label for="contract" className="form-label">
                              Contract{" "}
                              {singleLeads?.contract && (
                                <a
                                  href={singleLeads.contract}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="ms-2 text-primary"
                                >
                                  (View Current)
                                </a>
                              )}
                            </Label>
                            <div className="custom-file">
                              <input
                                type="file"
                                className="custom-file-input"
                                id="contract"
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                onChange={e => handleFileChange(setContract, e)}
                              />
                              {/* <label
                                className="custom-file-label"
                                htmlFor="contract"
                              >
                                {getFileName(contract)}
                              </label> */}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col lg={3}>
                          <div className="mb-4">
                            <QwikInput
                              name="follow_up_date"
                              label="Follow Up Date"
                              placeholder="Enter Follow Up Date"
                              type="date"
                              className="form-control"
                            />
                          </div>
                        </Col>

                        <Col lg={3}>
                          <div className="mb-4">
                            <QwikInput
                              name="follow_up_time"
                              label="Follow Up Time"
                              placeholder="Enter Follow Up Time"
                              type="time"
                              className="form-control"
                            />
                          </div>
                        </Col>

                        <Col lg={12}>
                          <div className="d-flex gap-2 mt-4">
                            <button
                              className="btn btn-primary waves-effect waves-light"
                              type="submit"
                              disabled={isLoading}
                            >
                              {isLoading ? "Updating..." : "Update Lead"}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={handleCancelEdit}
                            >
                              Cancel
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </QwikForm>
            </Row>
          )}

          <AddLeadSummaryModal
            isOpen={leadSummaryModal}
            toggle={() => setLeadSummaryModal(false)}
            lead={singleLeads}
            onLeadSummaryAdded={handleLeadSummaryAdded}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SingleLeads

// import Breadcrumb from "components/Common/Breadcrumb"
// import DynamicTextRows from "components/DynamicTextRows/DynamicTextRows"
// import QwikForm from "components/form/QwikForm"
// import QwikInput from "components/form/QwikInput"
// import QwikSelect from "components/form/QwikSelect"
// import React, { useEffect, useState } from "react"
// import { Col, Container, Row } from "reactstrap"
// import { parseISO, formatISO, format } from "date-fns"
// import { yupResolver } from "@hookform/resolvers/yup"
// import { clientLeadsSchema } from "schemas/clientLeadsSchema"
// import {
//   useCreateClientLeadMutation,
//   useGetClientLeadByIdQuery,
//   useUpdateClientLeadMutation,
// } from "store/features/clientLeads/clientLeadsManagement"
// import { toast } from "sonner"
// import { useParams } from "react-router-dom"
// import DashboardLoader from "components/Loader/DashboardLoader"
// const SingleLeads = () => {
//   const { id } = useParams()
//   const [rows, setRows] = useState([{ id: 1, note: "" }])
//   const { data: singleLeads, isLoading: loadingSingleLead } =
//     useGetClientLeadByIdQuery(id)
//   const [defaultValues, setDefaultValues] = useState({
//     name: "",
//     email: "",
//     company: "",
//     phone: "",
//     service_name: "",
//     requirements: "",
//     status: "",
//     start_date: null,
//     end_date: null,
//   })
//   const [updateClientLead, { isLoading }] = useUpdateClientLeadMutation()

//   useEffect(() => {
//     if (singleLeads) {
//       const formattedValues = {
//         ...singleLeads,
//         start_date: singleLeads.start_date
//           ? format(parseISO(singleLeads.start_date), "yyyy-MM-dd")
//           : null,
//         end_date: singleLeads.end_date
//           ? format(parseISO(singleLeads.end_date), "yyyy-MM-dd")
//           : null,
//       }
//       setDefaultValues(formattedValues)
//       setRows(singleLeads.summary || [{ id: 1, note: "" }])
//     }
//   }, [singleLeads, loadingSingleLead])

//   const handleSubmit = async (data, methods) => {
//     const startDate = formatISO(data.start_date)
//     const endDate = data.end_date ? formatISO(data.end_date) : null

//     data.start_date = startDate
//     data.end_date = endDate
//     data.summary = rows
//     const response = await updateClientLead(data)
//     if (response?.data?.id) {
//       toast.success("Client lead updated successfully")
//     } else {
//       toast.error("Error updating client lead")
//     }
//   }
//   if (loadingSingleLead) {
//     return <DashboardLoader />
//   }
//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid={true}>
//           <Breadcrumb title="Qwik IT" breadcrumbItem="View or Edit Leads" />
//           <Row>
//             <QwikForm
//               onSubmit={handleSubmit}
//               resolver={yupResolver(clientLeadsSchema)}
//               defaultValues={defaultValues}
//             >
//               <Col className="col-12">
//                 <Row>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <QwikInput
//                         name="name"
//                         label="Name"
//                         placeholder="Enter Name"
//                         type="text"
//                         className="form-control"
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <QwikInput
//                         name="email"
//                         label="Email"
//                         placeholder="Enter Email"
//                         type="text"
//                         className="form-control"
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <QwikInput
//                         name="company"
//                         label="Company Name"
//                         placeholder="Enter Company Name"
//                         type="text"
//                         className="form-control"
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <QwikInput
//                         name="phone"
//                         label="Phone"
//                         placeholder="Enter Phone"
//                         type="text"
//                         className="form-control"
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <QwikInput
//                         name="service_name"
//                         label="Service Name"
//                         placeholder="Enter Service Name"
//                         type="text"
//                         className="form-control"
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={6}>
//                     <div className="mb-3">
//                       <QwikInput
//                         name="requirements"
//                         label="Requirements"
//                         placeholder="Enter Requirements"
//                         type="textarea"
//                         className="form-control"
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="mb-3">
//                       <QwikSelect
//                         name="status"
//                         label="Status"
//                         options={[
//                           { value: "new", label: "New" },
//                           { value: "in_progress", label: "In Progress" },
//                           { value: "completed", label: "Completed" },
//                         ]}
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="mb-3">
//                       <QwikInput
//                         name="start_date"
//                         label="Start Date"
//                         placeholder="Enter Start Date"
//                         type="date"
//                         className="form-control"
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={4}>
//                     <div className="mb-3">
//                       <QwikInput
//                         name="end_date"
//                         label="End Date"
//                         placeholder="Enter End Date"
//                         type="date"
//                         className="form-control"
//                       />
//                     </div>
//                   </Col>
//                   <Col lg={12}>
//                     <div className="mb-3">
//                       <DynamicTextRows rows={rows} setRows={setRows} />
//                     </div>
//                   </Col>
//                   <div className="col-sm-6 text-start">
//                     <button
//                       className="btn btn-primary w-md waves-effect waves-light"
//                       type="submit"
//                       disabled={isLoading}
//                     >
//                       {isLoading ? "Updating..." : "Update Lead"}
//                     </button>
//                   </div>
//                 </Row>
//               </Col>
//             </QwikForm>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   )
// }

// export default SingleLeads
